"use client";

import Script from "next/script";

import { env } from "../../../utils/libs/env";

export function TagManagerScript() {
  return (
    <Script id="gtm" strategy="afterInteractive">
      {env.NEXT_PUBLIC_GTM_IDS.reduce(
        (snippet, id) => `
            ${snippet}
            (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
            'gtm.start':
            new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
            'https://tagging.bicevida.cl/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', '${id}');
          `,
        ""
      )}
    </Script>
  );
}

export function TagManagerIframe() {
  return (
    <noscript>
      {env.NEXT_PUBLIC_GTM_IDS.map((id) => (
        <iframe
          title="GTM"
          key={id}
          src={`https://www.googletagmanager.com/ns.html?id=${id}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      ))}
    </noscript>
  );
}
